'use client'

import { usePathname } from 'next/navigation'
import { useCallback, useRef } from 'react'

import { getPathWithoutLocale } from '../_utils/getPathWithoutLocale'

/** Standard order funnel entry (locale prefix stripped by {@link getPathWithoutLocale}). */
export const ORDER_FLOW_BASE_PATH = '/volne-terminy'

export function isOrderFlowPath(pathWithoutLocale: string): boolean {
	const path = pathWithoutLocale.split('?')[0] ?? ''
	return path === ORDER_FLOW_BASE_PATH || path.startsWith(`${ORDER_FLOW_BASE_PATH}/`)
}

/**
 * Merges optional `onClick` (e.g. close header UI) with order-funnel behaviour: navigate to a clean
 * {@link ORDER_FLOW_BASE_PATH} (no query params) when the user is already in the funnel so the order
 * flow resets to step 1.
 */
export function useHeaderOrderOnlineNavigateClick(
	beforeReload?: (event: React.MouseEvent<HTMLAnchorElement>) => void
) {
	const pathname = usePathname()
	const beforeRef = useRef(beforeReload)
	beforeRef.current = beforeReload

	return useCallback((event: React.MouseEvent<HTMLAnchorElement>) => {
		beforeRef.current?.(event)
		const path = getPathWithoutLocale(pathname)
		if (isOrderFlowPath(path)) {
			event.preventDefault()
			window.location.assign(ORDER_FLOW_BASE_PATH)
		}
	}, [pathname])
}
